import { useMemo } from "react";

import ApplicationInput from "~/components/application/input";
import ApplicationRulesOfSilencio from "~/components/application/ruleOfSilencio";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { countries, nationalities } from "~/utils/constants/countries";
import { genders, gendersEn } from "~/utils/constants/genders";
import { objectToSelectionSet } from "~/utils/functions/general.functions";

const ApplicationAboutYouAddressAndBirthday = () => {
  const { language } = useLanguage();

  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;

  const nationalitySelectOptions = useMemo(() => {
    return objectToSelectionSet(nationalities);
  }, [nationalities, objectToSelectionSet]);

  const genderSelectOptions = useMemo(() => {
    return objectToSelectionSet(language === "En" ? gendersEn : genders);
  }, [language, genders, gendersEn, objectToSelectionSet]);

  const placeOfResidencySelectOptions = useMemo(() => {
    return objectToSelectionSet(countries);
  }, [countries, objectToSelectionSet]);

  return (
    <>
      <div>
        <p>Coordonnées</p>
        <ApplicationInput
          register="phoneNumber"
          placeholder={applyTexts.applicationForm.phoneNumber}
          label={applyTexts.applicationForm.phoneNumber}
          required={true}
          size={13}
        />
        <br />
        <ApplicationInput
          register="addressLine1"
          placeholder={applyTexts.applicationForm.address1}
          label={applyTexts.applicationForm.address1}
          size={12}
        />
        <br />
        <ApplicationInput
          register="addressLine2"
          placeholder={applyTexts.applicationForm.address2}
          label={applyTexts.applicationForm.address2}
          size={12}
        />
        <br />
        <ApplicationInput
          register="city"
          placeholder={applyTexts.applicationForm.city}
          label={applyTexts.applicationForm.city}
          size={4}
        />
        <ApplicationInput
          register="postalCode"
          placeholder={applyTexts.applicationForm.postalCode}
          label={applyTexts.applicationForm.postalCode}
          size={12}
        />
      </div>
      <div>
        <p>{applyTexts.applicationForm.dob}</p>
        <ApplicationInput
          register="birthDate"
          placeholder="Birth Date MM/DD/YYYY"
          label="birthDate"
          type="date"
          required={true}
          // size={19}
          // onClick={handleOpenModal}
          // value={birthdate.valueOf().toString()}
          // defaultValue={date18YearsAgo.toISOString().split("T")[0]}
        />
        <br />
        <ApplicationInput
          register="nationality"
          placeholder="Français"
          label="nationality"
          type="select"
          required={true}
          selectOptions={nationalitySelectOptions}
          defaultValue="FR"
        />
        <br />
        <ApplicationInput
          register="gender"
          placeholder={applyTexts.applicationForm.gender}
          label={applyTexts.applicationForm.gender}
          type="select"
          required={true}
          selectOptions={genderSelectOptions}
        />
        <br />
        <ApplicationInput
          register="placeOfResidency"
          placeholder={applyTexts.applicationForm.por}
          label={applyTexts.applicationForm.por}
          type="select"
          required={true}
          selectOptions={placeOfResidencySelectOptions}
        />
      </div>

      <p>
        *{applyTexts.applicationForm.dataStore}{" "}
        <ApplicationRulesOfSilencio
          text={`→ ${applyTexts.applicationForm.privacyPolicy}`}
        />
      </p>
    </>
  );
};

export default ApplicationAboutYouAddressAndBirthday;
